import { render, staticRenderFns } from "./AllStaff.vue?vue&type=template&id=9b6e2662&scoped=true"
import script from "./AllStaff.vue?vue&type=script&lang=js"
export * from "./AllStaff.vue?vue&type=script&lang=js"
import style0 from "./AllStaff.vue?vue&type=style&index=0&id=9b6e2662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6e2662",
  null
  
)

export default component.exports